import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Welcome() {
  const navigate = useNavigate();
  return (
    <div className="welcome-container" style={{ 
      textAlign: 'center', padding: '100px 20px', 
      backgroundColor: '#06392f', color: 'white', minHeight: '100vh' 
    }}>
      <h1>surragne</h1>
      <p>Master your money through Socratic coaching.</p>
      <button onClick={() => navigate('/dashboard')} className="finish-btn">
        Start Journey
      </button>
    </div>
  );
}
